import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DomainState, RootState } from './domain-types';

export const state: DomainState = {
  domain: undefined,
  error: false,
};

const namespaced = true;

export const domain: Module<DomainState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
